import { constants } from "../constants";

export const changeLanguage = (lang = "en") => dispatch => {
  const allowedLangs = ["en", "fr"];
  if (!allowedLangs.includes(lang)) lang = "en";
  localStorage.setItem("lang", lang);
  dispatch({ type: constants.CHANGE_LANGUAGE, payload: lang });
};
